module.exports = __webpack_public_path__ + "img/apple.7a72246f.png";